// extracted by mini-css-extract-plugin
module.exports = {"locl-back-to-search-results__link":"back-to-search-results_locl-back-to-search-results__link__0aEfs"};